export default __webpack_public_path__ + "static/media/givepower-Lockup-H-wht.d2c926d9.svg";